'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGTextStyle = require('./SVGTextStyle');

var _SVGTextStyle2 = _interopRequireDefault(_SVGTextStyle);

var _SVGWrapper = require('./SVGWrapper');

var _SVGWrapper2 = _interopRequireDefault(_SVGWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SVGText = function SVGText(props) {
  var wrapperProps = props.wrapperProps,
      innerProps = _objectWithoutProperties(props, ['wrapperProps']);

  return _react2.default.createElement(
    _SVGWrapper2.default,
    wrapperProps,
    _react2.default.createElement(_SVGTextStyle2.default, innerProps)
  );
};

SVGText.propTypes = {
  wrapperProps: _react.PropTypes.any
};

exports.default = SVGText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/SVGText.js
// module id = 1004
// module chunks = 2 3